const dropdown = {
    build(select) {
        const wrapper = document.createElement("div");
        wrapper.className = "image-select";
        select.parentNode.insertBefore(wrapper, select);
        wrapper.appendChild(select);
        select.classList.add("image-select-native");
        const toggle = document.createElement("button");
        toggle.type = "button";
        toggle.className = "image-select-toggle";
        toggle.innerHTML = "<span>Select...</span>";
        wrapper.appendChild(toggle);
        const menu = document.createElement("div");
        menu.className = "image-select-menu";
        wrapper.appendChild(menu);
        [...select.options].forEach(option => {
            const isPlaceholder = option.value === "";
            const item = document.createElement("div");
            item.className = "image-select-option";
            item.dataset.value = option.value;
            const img = option.dataset.img
                ? `<img alt="${item.dataset.value}" src="${option.dataset.img}">`
                : "";
            const xIcon = isPlaceholder
                ? `<span class="image-select-close"></span>`
                : "";
            item.innerHTML = `
                ${img}
                <span>${option.text}</span>
                ${xIcon}
            `;
            item.addEventListener("click", () => {
                dropdown.setValue(select, menu, option.value);
            });
            menu.appendChild(item);
        });
        select.addEventListener("change", () => {
            dropdown.updateDisplay(select, toggle);
            dropdown.setSelected(menu, select.value);
        });
        toggle.addEventListener("click", () => {
            const isOpen = wrapper.classList.contains("open");
            if (isOpen) {
                dropdown.close(wrapper);
                return;
            }
            wrapper.classList.add("open");
            if (dropdown.isMobile()) {
                dropdown.lockScroll(true);
            } else {
                const direction = dropdown.openDirection(wrapper, menu);
                wrapper.classList.add(
                    "up" === direction
                        ? "open-up"
                        : "open-down"
                );
            }
            dropdown.onOpen(menu);
        });
        toggle.addEventListener("pointerup", e => {
            e.stopPropagation();
            document.dispatchEvent(
                new CustomEvent("dropdown:clicked", {
                    detail: { target: select.id }
                })
            );
        });
        dropdown.updateDisplay(select, toggle);
    },
    close(wrapper) {
        wrapper.classList.remove("open", "open-up", "open-down");
        if (this.isMobile()) {
            this.lockScroll(false);
        }
    },
    handleKeydown(e) {
        if ("Escape" === e.key) {
            e.stopPropagation();
            document.querySelectorAll(".image-select.open").forEach(wrapper => {
                dropdown.close(wrapper);
                const toggle = wrapper.querySelector(".image-select-toggle");
                if (toggle) {
                    toggle.focus();
                }
            });
        }
    },
    handleOutsideClick(e) {
        document.querySelectorAll(".image-select").forEach(wrapper => {
            if (!wrapper.contains(e.target)) {
                dropdown.close(wrapper);
            }
        });
    },
    handleScroll() {
        document.querySelectorAll(".image-select.open").forEach(wrapper => {
            const menu = wrapper.querySelector(".image-select-menu");
            if (window.innerWidth <= dropdown.locals.MOBILE_BREAK) {
                return;
            }
            const newDirection = dropdown.openDirection(wrapper, menu);
            const isUp = wrapper.classList.contains("open-up");
            if (
                ("up" === newDirection && !isUp)
                    || ("down" === newDirection && isUp)
            ) {
                wrapper.classList.toggle("open-up", "up" === newDirection);
                wrapper.classList.toggle("open-down", "down" === newDirection);
            }
        });
    },
    init() {
        document.querySelectorAll(".colors-dropdown").forEach(select => {
            dropdown.build(select);
        });
        document.addEventListener("click", dropdown.handleOutsideClick);
        document.addEventListener("keydown", dropdown.handleKeydown);
        window.addEventListener("scroll", dropdown.handleScroll, { passive: true });
    },
    isMobile() {
        return window.matchMedia(`(max-width: ${this.locals.MOBILE_BREAK}px)`).matches;
    },
    locals: {
        MOBILE_BREAK: 991,
    },
    lockScroll(lock) {
        if (lock) {
            if ("hidden" !== document.body.style.overflow) {
                document.body.style.overflow = "hidden";
            }
            return;
        }
        const anyOpen = document.querySelector(".image-select.open");
        if (!anyOpen
            && "hidden" === document.body.style.overflow
        ) {
            document.body.style.overflow = "";
        }
    },
    onOpen(menu) {
        const selected = menu.querySelector(".image-select-option.selected");
        if (!selected) {
            return;
        }
        dropdown.scrollToSelected(menu, selected.dataset.value);
    },
    openDirection(wrapper, menu) {
        const toggle = wrapper.querySelector(".image-select-toggle");
        const rect = toggle.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        const menuHeight = Math.min(300, viewportHeight * 0.6);
        const spaceBelow = viewportHeight - rect.bottom;
        const spaceAbove = rect.top;
        const openDown = spaceBelow >= menuHeight
            || spaceBelow >= spaceAbove;
        return openDown
            ? "down"
            : "up";
    },
    reset() {
        document.querySelectorAll(".colors-dropdown").forEach(select => {
            const wrapper = select.closest(".image-select");
            const menu = wrapper?.querySelector(".image-select-menu");
            if (!wrapper
                || !menu
            ) {
                return;
            }
            const options = [...select.options].filter(option => option.value !== "");
            const value = 1 === options.length
                ? options[0].value
                : "";
            dropdown.setValue(select, menu, value);
            if ("" === value) {
                menu.querySelector('.image-select-option[data-value=""]')?.classList.add("selected");
            }
        });
    },
    scrollToSelected(menu, value) {
        const selected = menu.querySelector(`[data-value="${value}"]`);
        if (!selected) {
            return;
        }
        const container = menu;
        const offsetTop = selected.offsetTop;
        const containerHeight = container.clientHeight;
        container.scrollTo({
            top: offsetTop - containerHeight / 2,
            behavior: 'smooth'
        });
    },
    setSelected(menu, value) {
        const items = menu.querySelectorAll('.image-select-option');
        items.forEach(opt => {
            const isValid = "" !== opt.dataset.value;
            const isSelected = isValid
                && value === opt.dataset.value ;
            opt.classList.toggle('selected', isSelected);
        });
    },
    setValue(select, menu, value) {
        select.value = value;
        select.dispatchEvent(new Event("change", { bubbles: true }));
        requestAnimationFrame(() => {
            dropdown.close(select.closest(".image-select"));
        });
    },
    updateDisplay(select, toggle) {
        const selected = select.selectedOptions[0];
        if (!selected) return;
        let imgEl = toggle.querySelector(".toggle-image");
        let textEl = toggle.querySelector(".toggle-text");
        let labelEl = toggle.querySelector(".toggle-label");
        if (!textEl) {
            toggle.innerHTML = `
                <img alt="" class="toggle-image">
                <span class="toggle-text"></span>
                <span class="toggle-label"></span>
            `;
            imgEl = toggle.querySelector(".toggle-image");
            textEl = toggle.querySelector(".toggle-text");
            labelEl = toggle.querySelector(".toggle-label");
        }
        // update content (no DOM replacement)
        if (selected.dataset.img) {
            imgEl.alt = selected.dataset.alt || selected.text;
            imgEl.src = selected.dataset.img;
            imgEl.style.display = "";
        } else {
            imgEl.style.display = "none";
        }
        textEl.textContent = selected.text;
        labelEl.textContent = select.dataset.label ?? "";
        const hasValue = selected.value !== "";
        labelEl.style.display = hasValue ? "block" : "none";
        labelEl.style.opacity = hasValue ? "1" : "0";
        labelEl.style.pointerEvents = hasValue ? "auto" : "none";
    },
};
$(() => {
    dropdown.init();
});
